import "./documentRichTextField.css";
import Trix from "trix";
import { useRef } from "react";
import { VStack } from "@chakra-ui/react";
import CDS from "design-system";
import TrixEditor from "components/FormElements/Fields/TrixTextAreaField/TrixEditor";
import PersonalizationTokenMenu from "components/FormElements/Fields/TemplateRichTextAreaField/PersonalizationTokenMenu";
import { RichText } from "components/FormElements/Fields/TrixTextAreaField/trixrichtext";
import useModal from "hooks/useModal";

interface DocumentRichTextFieldProps {
  name: string;
  label: string;
  placeholder: string;
  control: any;
  reserveToolbarSpace?: boolean;
}

export default function DocumentRichTextField({ name, label, placeholder, control, reserveToolbarSpace = false }: DocumentRichTextFieldProps) {
  const trixRef = useRef<Trix>(null);
  const {
    open: openPersonalizationTokenModal,
    close: closePersonalizationTokenModal,
    Modal: PersonalizationTokenModal,
  } = useModal({
    headerTitle: "Insert Token",
    headerFontSize: "lg",
    size: "lg",
    isCentered: true,
  });

  return (
    <>
      <VStack spacing={1} align="stretch" className="document-rich-text-field">
        <CDS.Text14 fontWeight="semibold" color="content.primary">
          {label}
        </CDS.Text14>
        <TrixEditor
          trixRef={trixRef}
          name={name}
          control={control}
          placeholder={placeholder}
          hideToolbar={false}
          maintainToolbarSpace={reserveToolbarSpace}
          includeAttachment
          onInitialize={(_: any, richText: RichText) => {
            richText.insertPersonalizationElements();
            richText.personalizationTokenButton.addEventListener("click", () => {
              openPersonalizationTokenModal();
            });
          }}
        />
      </VStack>
      <PersonalizationTokenModal>
        <PersonalizationTokenMenu
          actionType="meeting"
          onSelect={(token) => {
            const { editor } = (trixRef.current as any);
            const attachment = new Trix.Attachment({ content: token.content, sgid: token.sgid });
            editor.insertAttachment(attachment);
            closePersonalizationTokenModal();
          }}
        />
      </PersonalizationTokenModal>
    </>
  );
}
